/* eslint-disable unicorn/no-array-for-each */

/* eslint-disable unicorn/prefer-string-slice */
/* eslint-disable unicorn/new-for-builtins */
/* eslint-disable unicorn/no-static-only-class */
export class Url {
  static isValid(url: string, strict = true): boolean {
    const regex = RegExp(this.urlRegex(strict), 'i')

    return !!regex.test(url)
  }

  /**
   * Returns an object with the query parameters.
   */
  static getQueryParameters(url: string): Record<string, string> {
    url = decodeURIComponent(url.substr(url.indexOf('?') + 1, url.length))

    const parts = url.split('&')
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const result: Record<string, any> = {}

    parts.forEach((part: string) => {
      const pieces = part.split('=')
      let key = pieces[0]
      const value = pieces[1]

      const matches = key.match(/\[(.*?)\]+/)

      if (!matches || matches.length === 0) {
        result[`${key}`] = value
      }

      if (matches && matches.length > 1) {
        key = key.substr(0, key.indexOf('['))
        matches.shift()
        matches.forEach((match: string) => {
          if (!result[`${key}`]) {
            result[`${key}`] = {}
          }

          result[`${key}`][`${match}`] = value
        })
      }
    })

    return result
  }

  static urlRegex(strict = true): string {
    let regex = strict ? String.raw`^(?:(?:(?:https?|ftp):)?\/\/)` : String.raw`^(?:(?:(?:https?|ftp):)?\/\/)?` // protocol

    regex +=
      // protocol identifier (optional)
      // short syntax // still required
      // user:pass BasicAuth (optional)
      String.raw`(?:\S+(?::\S*)?@)?` +
      '(?:' +
      // IP address exclusion
      // private & local networks
      String.raw`(?!(?:10|127)(?:\.\d{1,3}){3})` +
      String.raw`(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})` +
      String.raw`(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})` +
      // IP address dotted notation octets
      // excludes loopback network 0.0.0.0
      // excludes reserved space >= 224.0.0.0
      // excludes network & broadcast addresses
      // (first & last IP address of each class)
      String.raw`(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])` +
      String.raw`(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}` +
      String.raw`(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))` +
      '|' +
      // host & domain names, may end with dot
      // can be replaced by a shortest alternative
      // (?![-_])(?:[-\\w\\u00a1-\\uffff]{0,63}[^-_]\\.)+
      '(?:' +
      '(?:' +
      String.raw`[a-z0-9\u00a1-\uffff]` +
      String.raw`[a-z0-9\u00a1-\uffff_-]{0,62}` +
      ')?' +
      String.raw`[a-z0-9\u00a1-\uffff]\.` +
      ')+' +
      // TLD identifier name, may end with dot
      String.raw`(?:[a-z\u00a1-\uffff]{2,}\.?)` +
      ')' +
      // port number (optional)
      String.raw`(?::\d{2,5})?` +
      // resource path (optional)
      String.raw`(?:[/?#]\S*)?` +
      '$'

    return regex
  }
}
